import { render, staticRenderFns } from "./UserDetailForm.vue?vue&type=template&id=f3d0a674&"
import script from "./UserDetailForm.vue?vue&type=script&lang=js&"
export * from "./UserDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports